export default {
  // 是否显示cookie隐私，只有海外版用
  showCookiePolicy: false,
  showPcgTerm: true,
  footerLocale: 'ZH_CN',
  serviceTermUrl: '',
  privacyPolicyUrl: '',
};
